import React, { useEffect, useState } from 'react';
import { Table, SearchInput } from 'components';
import { FormDetail } from './form-detail';
import { Box } from '@mui/material';
import { BsPlus } from 'react-icons/bs';
import ApiServices from 'services';
import { Columns } from './columns';
import { ContainerHeader, ButtonAdd } from './styles';

function SubServicePage() {
  const [subServiceList, setSubServiceList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  const initData = async () => {
    setLoading(true);
    try {
      const { data } = await ApiServices.getsubServices();
      setSubServiceList(data || []);
    } catch (err) {
      console.warn('initData - Sub Service', err);
    }
    setLoading(false);
  };
  useEffect(() => {
    initData();
  }, []);

  const deleteSubServiceItem = async (row) => {
    setLoading(true);
    try {
      const res = await ApiServices.deletesubService(row.id);
      if (res) {
        window.UIMessage?.success('Xóa thành công');
        initData();
      }
    } catch (err) {
      window.UIMessage?.error('Xóa thất bại !!!');
      console.warn('deleteSubServiceItem - Sub Service', err);
    }
    setLoading(false);
  };

  const renderHeader = () => (
    <>
      <ContainerHeader>
        <SearchInput sx={{ mr: 2 }} maxWidth={400} />
      </ContainerHeader>
      <ButtonAdd
        variant="contained"
        size="small"
        startIcon={<BsPlus />}
        onClick={() => setSelected({ isNew: true })}
      >
        Thêm mới
      </ButtonAdd>
    </>
  );

  return (
    <Box sx={{ width: '100%' }}>
      <Table
        rows={subServiceList}
        headCells={Columns(deleteSubServiceItem)}
        onClickDetail={(row) => setSelected(row)}
        title="Dịch vụ phụ"
        loading={loading}
        renderHeader={renderHeader}
      />
      <FormDetail {...{ selected, setSelected, initData }} />
    </Box>
  );
}
export { SubServicePage };
